import { useCallback, useEffect, useState, type FormEvent } from "react";
import { Link, useParams } from "react-router-dom";
import { api, errMsg, fmtDate, PLAN_LABEL } from "../../api";
import { Btn, Field, Input, Notice, PageHead, Select } from "../../components/ui";
import { useMe } from "../../session";

interface Detail {
  tenant: { id: string; kind: "pf" | "pj"; name: string; plan: string; status: string; currency: string; createdAt: string };
  recentEvents: { id: number; at: string; action: string; details: Record<string, unknown> }[];
}

export function ClientDetail() {
  const { id } = useParams();
  const { me } = useMe();
  const isGeneral = me.user.role === "administrador_geral";
  const [d, setD] = useState<Detail | null>(null);
  const [plan, setPlan] = useState("teste");
  const [reason, setReason] = useState("");
  const [msg, setMsg] = useState<{ kind: "ok" | "error"; text: string } | null>(null);

  const load = useCallback(async () => {
    try { const r = await api<Detail>("GET", `/api/admin/tenants/${id}`); setD(r); setPlan(r.tenant.plan); }
    catch (e) { setMsg({ kind: "error", text: errMsg(e) }); }
  }, [id]);
  useEffect(() => { void load(); }, [load]);

  async function save(e: FormEvent) {
    e.preventDefault();
    try {
      const r = await api<{ changed: boolean }>("PUT", `/api/admin/tenants/${id}/plan`, { plan, reason });
      setMsg({ kind: "ok", text: r.changed ? "Plano atualizado e registrado na auditoria." : "O plano já era este." });
      setReason(""); await load();
    } catch (e2) { setMsg({ kind: "error", text: errMsg(e2) }); }
  }

  if (!d) return <>{msg && <Notice kind="error">{msg.text}</Notice>}</>;
  const t = d.tenant;
  return (
    <>
      <p style={{ marginTop: 0 }}><Link to="/admin">← Clientes</Link></p>
      <PageHead title={t.name} sub={`${t.kind === "pf" ? "Pessoa Física" : "Pessoa Jurídica"} · criado em ${fmtDate(t.createdAt)}`} />
      {msg && <div style={{ maxWidth: 640 }}><Notice kind={msg.kind}>{msg.text}</Notice></div>}
      <div className="card" style={{ maxWidth: 640, marginBottom: 16 }}>
        <dl className="kv">
          <dt>Plano atual</dt><dd><span className="pill accent">{PLAN_LABEL[t.plan]}</span></dd>
          <dt>Situação</dt><dd>{t.status === "ativo" ? "Ativo" : "Suspenso"}</dd>
          <dt>Moeda principal</dt><dd className="tabular">{t.currency}</dd>
        </dl>
      </div>
      {isGeneral ? (
        <form className="card" style={{ maxWidth: 640, marginBottom: 16 }} onSubmit={save}>
          <h3 style={{ fontSize: 16, marginBottom: 12 }}>Atribuir plano</h3>
          <Field label="Plano">
            <Select value={plan} onChange={(e) => setPlan(e.target.value)}>
              {Object.entries(PLAN_LABEL).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
            </Select>
          </Field>
          <Field label="Motivo (registrado na auditoria)"><Input required minLength={5} value={reason} onChange={(e) => setReason(e.target.value)} /></Field>
          <Btn type="submit" disabled={plan === t.plan}>Salvar plano</Btn>
        </form>
      ) : (
        <Notice>Somente o Administrador Geral pode alterar o plano.</Notice>
      )}
      {isGeneral && (
        <div className="card" style={{ maxWidth: 640, padding: 0 }}>
          <table>
            <thead><tr><th>Quando</th><th>Evento</th></tr></thead>
            <tbody>
              {d.recentEvents.map((e) => <tr key={e.id}><td>{fmtDate(e.at)}</td><td className="tabular">{e.action}</td></tr>)}
              {d.recentEvents.length === 0 && <tr><td colSpan={2} className="muted">Sem eventos.</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
